<div class="mobile-app-download-links">
  <app-link *ngIf="appStoreLink" displayText="" [url]="appStoreLink">
    <img src="../../../assets/images/app-store.svg" alt="App Store" />
  </app-link>

  <app-link *ngIf="googlePlayLink" displayText="" [url]="googlePlayLink">
    <img src="../../../assets/images/google-play.svg" alt="Google Play" />
  </app-link>

  <app-link *ngIf="ruStoreLink" displayText="" [url]="ruStoreLink">
    <img src="../../../assets/images/ru-store.svg" alt="RuStore" />
  </app-link>
</div>
